import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BookingResultsContainerComponent } from './booking-results-container.component';
import { NotificationModule } from 'libraries/component/notification/notification.module';
import { BookingsListModule } from '../bookings-list/booking-list.module';
import { PopupMenuModule } from 'libraries/component/popup-menu/popup-menu.module';
import { LoaderModule } from 'libraries/component/loader/loader.module';
import { CardModule } from 'libraries/ui_card/card.module';
import { ProcessingEmailService } from '../../../processing-email/services/processing-email.service';
import { PermissionModule } from "libraries/permission/permission.module";
import { BookingProcessingMenuModule } from 'app_sasha/shared/services/booking-processing-menu/booking-processing-menu.module';
import { MatDialogModule } from '@angular/material/dialog';
import { ConfirmDialogModule } from 'libraries/component/dialogs/confirm-dialog/confirm-dialog.module';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {BtnModule} from "libraries/ui_button/btn.module";
import {BookingResourceModule} from "libraries/service/resources/booking/bookingResource.module";
import {
    DictionarySearchResourceModule
} from "libraries/service/resources/dictionary-search/dictionary-search-resource.module";
import {
    ConfigurableTableModule
} from "libraries/component/table/configurable-table/configurable-table.module";

@NgModule({
    imports: [
        CommonModule,
        BtnModule,
        NotificationModule,
        BookingsListModule,
        PopupMenuModule,
        LoaderModule,
        CardModule,
        PermissionModule,
        BookingProcessingMenuModule,
        MatDialogModule,
        ConfirmDialogModule,
        FontAwesomeModule,
        BookingResourceModule,
        DictionarySearchResourceModule,
        ConfigurableTableModule,
    ],
    exports: [
        BookingResultsContainerComponent,
    ],
    declarations: [
        BookingResultsContainerComponent,
    ],
    providers: [
        ProcessingEmailService,
    ],
})
export class BookingResultsContainerModule { }
